import { useQuery } from '@hooks/reactQuery';

import { getNetconfEvents } from '@api/netconfEvents';

import { extractQueryParams } from '@utils/common';

import { IIsEnabled } from '@interfaces/common/defaultDTO';
import { INetconfEventsDTO } from '@interfaces/vesData/dto/netconfEventsDTO';
import { INetconfEvent } from '@interfaces/vesData/netconfEvents';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETCONF_EVENTS } from '@constants/queryKeys';

interface IUseQueryNetconfEventsReturned {
	netconfEvents: INetconfEvent[];
	isLoadingNetconfEvents: boolean;
	countOfRecords: number;
}

export const useQueryNetconfEvents = (params: INetconfEventsDTO & IIsEnabled): IUseQueryNetconfEventsReturned => {
	const {
		isEnabled,
		...dto
	} = params;

	const { data, isInitialLoading } = useQuery({
		queryKey: [NETCONF_EVENTS, dto, isEnabled],
		queryFn: extractQueryParams(getNetconfEvents),
		enabled: [isEnabled],
		allowedRoles: [EUserRoles.smoLightUpdater, EUserRoles.smoLightViewer],
		...refetchOptions,
	});

	return {
		netconfEvents: data?.items || [],
		isLoadingNetconfEvents: isInitialLoading,
		countOfRecords: data?.count || 0,
	};
};
